module.exports = __webpack_public_path__ + "img/TractionMpos.45c5a0b6.png";